import { render, staticRenderFns } from "./DetailViews.vue?vue&type=template&id=1cfa834f&scoped=true&"
import script from "./DetailViews.vue?vue&type=script&lang=js&"
export * from "./DetailViews.vue?vue&type=script&lang=js&"
import style0 from "./DetailViews.vue?vue&type=style&index=0&id=1cfa834f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa834f",
  null
  
)

export default component.exports